import React from "react"
import { useToken } from "trux"
import { useGetUserDivisionQuery } from "../../generated/graphql"

let CZ_IS_SETUP = false

/**
 * Loads user info including recent division id and sets churn zero contact info
 * @returns {null}
 * @constructor
 */
const LoadChurnZero = () => {
    // Get the token
    const token = useToken("LoadChurnZero")
    const tokenReady = token && token.user_id > 0

    const [czUserNfo, setCzUserNfo] = React.useState({
        email: null,
        divisionId: null,
    })

    // Get the user division
    const { data } = useGetUserDivisionQuery({
        variables: {
            user_id: token?.user_id,
            token: token,
        },
        skip: !tokenReady,
    })

    if (!window.ChurnZero) {
        // abort cz is not loaded
        console.log("--- ChurnZero not loaded ---")
        return null
    }

    if (!CZ_IS_SETUP) {
        CZ_IS_SETUP = true
        window.ChurnZero.push(["urltracking", false])
        window.ChurnZero.push([
            "setAppKey",
            "1!xjcIPLxUn9OnVVV-IQtgV4ex5LAENPp9NqZTqEsnmWgtADF",
        ])
    }

    if (
        data?.user?.recent_division_id &&
        data?.user?.email &&
        data.user.recent_division_id !== czUserNfo.divisionId &&
        data.user.email !== czUserNfo.email
    ) {
        // Set the contact info
        window.ChurnZero.push([
            "setContact",
            data.user.recent_division_id,
            data.user.email,
        ])
        setCzUserNfo({
            email: data.user.email,
            divisionId: data.user.recent_division_id,
        })
    }

    return null
}

export default LoadChurnZero
